module.exports = __webpack_public_path__ + "static/media/munch5.a79a187c.wav";